<template>
  <div class="home">
    <template v-if="hasRound">
      <SuggestionForm v-if="isFirstRound()" />
      <template v-else>
        <tabs />
        <div v-html="round.description" class="html"></div>
        <router-link v-if="categories.length > 0" :to="urlForCategory(categories[0])" class="button">
          Start met stemmen
        </router-link>
      </template>
    </template>
    <p v-else-if="failed">Er is op het moment geen actieve stem ronde.</p>
    <p v-else>Het is momenteel niet mogelijk om te stemmen.</p>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs'
import SuggestionForm from './SuggestionForm.vue'
import isFirstRound from '../util/firstRound'

export default {
  name: 'Home',

  components: {
    SuggestionForm,
    tabs: Tabs
  },

  computed: {
    rounds() {
      return this.$store.state.rounds
    },

    hasRound() {
      return this.rounds.length
    },

    round() {
      return this.rounds[0]
    },

    categories() {
      return this.$store.state.categories
    },

    category() {
      return this.categories[0]
    },

    failed() {
      return this.$store.state.failedFetch
    },

    hasSingleCategory() {
      return this.categories.length === 1
    },

    styles() {
      return this.hasRound && this.round.image
        ? {
            backgroundImage: `url(${this.round.image})`
          }
        : {}
    }
  },
  methods: {
    isFirstRound,
    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue